import { render, staticRenderFns } from "./coupon-pkg-details.vue?vue&type=template&id=5593844d"
import script from "./coupon-pkg-details.vue?vue&type=script&lang=js"
export * from "./coupon-pkg-details.vue?vue&type=script&lang=js"
import style0 from "./coupon-pkg-details.vue?vue&type=style&index=0&id=5593844d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5593844d')) {
      api.createRecord('5593844d', component.options)
    } else {
      api.reload('5593844d', component.options)
    }
    module.hot.accept("./coupon-pkg-details.vue?vue&type=template&id=5593844d", function () {
      api.rerender('5593844d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/components/coupon/coupon-pkg-details.vue"
export default component.exports